import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { BarChart } from '../../../../components/BarChart';
import { LineChart } from '../../../../components/LineChart';
import { Loader } from '../../../../components/Loader';
import useStyles from '../../styles';

const CHOSEN_DATA = {
  logins: {
    title: 'page.analytics.learningSessions',
    description: 'page.analytics.learningSessionsDesc',
    graph: (data, groupBy, from, to) => (
      <LineChart
        from={from}
        to={to}
        data={data}
        axis
        chosen
        groupBy={groupBy}
        enableGridY
        enableArea
        name="bigChosen"
      />
    ),
  },
  hours: {
    title: 'page.analytics.viewingHours',
    description: 'page.analytics.viewingHoursDesc',
    graph: (data, groupBy, from, to) => (
      <LineChart
        from={from}
        to={to}
        data={data}
        axis
        chosen
        groupBy={groupBy}
        enableGridY
        enableArea
        name="bigChosen"
      />
    ),
  },
  videos: {
    title: 'page.analytics.videoesWatched',
    description: 'page.analytics.videosWatchedDesc',
    graph: (data, groupBy, from, to) => (
      <BarChart
        from={from}
        to={to}
        data={data}
        axis
        chosen
        groupBy={groupBy}
        enableGridY
        name="bigChosen"
      />
    ),
  },
};

interface ChosenGraphProps {
  type?: any;
  data?: any;
  groupBy?: any;
  loading?: boolean;
  from?: Date;
  to?: Date;
}

const ChosenGraph: FC<ChosenGraphProps> = ({ type, data, groupBy, loading, from, to }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const chosenData = data[type];

  return (
    <div className={classes.chosenBlock}>
      <p data-testid="graphTitle" className={classes.chosenTitle}>
        {t(CHOSEN_DATA[type].title)}
      </p>
      <p data-testid="graphSubtitle" className={classes.chosenDescription}>
        {t(CHOSEN_DATA[type].description)}
      </p>

      <div className={classes.chosenGraphWrap}>
        {loading ? (
          <Loader global={false} />
        ) : (
          <>{CHOSEN_DATA[type].graph(chosenData, groupBy, from, to)}</>
        )}
      </div>
    </div>
  );
};

export default ChosenGraph;
